import idx from 'idx';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleAddParticipants } from 'focus_groups/ducks/view_state';

import ParticipantList from 'focus_groups/components/participant_list';

export function mapStateToProps(state) {
  const {
    currentGroup, showAddParticipants,
  } = idx(state, _ => _.project.focusGroups.viewState) || {};
  return { group: currentGroup, showAddParticipants };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleAddParticipants,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantList);



// WEBPACK FOOTER //
// ./focus_groups/containers/participant_list.js